
import React, { useEffect } from "react";
import "./PressOnly.css";
import SuitableFor from "./SuitableFor";
import CleanServicesLaundry from "../CleanServicesLaundry/CleanServicesLaundry";
import PressOnlyServices from "./PressOnlyServices/PressOnlyServices";
import AOS from "aos";
import PressWash from "../WhitePlus/PressWash"
import "aos/dist/aos.css";
const pressImg =
  "/sabmenu/servicesArtboard-1-copy-11.webp";

export default function PressOnly() {
      useEffect(() => {
        AOS.init({
          duration: 1200,
          easing: "ease-in-out",
          once: true,
          offset: 80,
        });
      }, []);
  return (
    <div>
  
    <div className="" data-aos="zoom-in-right">
  <PressOnlyServices />
</div>
       <PressWash/>

    <div className="" data-aos="zoom-in-right">
    <CleanServicesLaundry />
</div>



<div className="" data-aos="zoom-in-right">
<SuitableFor />
</div>

    </div>
 
  );
}
